var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 26338"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 20.0002H0V1.81836H2.72727V3.63654H1.81818V18.182H18.1818V3.63654H16.3636V1.81836H20V20.0002Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.5449 1.81836H4.54492V3.63654H14.5449V1.81836Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.4549 0H3.63672V5.45455H5.4549V0Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.2733 0H15.4551V5.45455H17.2733V0Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.09162 7.27246H7.27344V9.09064H9.09162V7.27246Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M12.7264 7.27246H10.9082V9.09064H12.7264V7.27246Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M16.3631 7.27246H14.5449V9.09064H16.3631V7.27246Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M5.4549 10.9092H3.63672V12.7274H5.4549V10.9092Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M9.09162 10.9092H7.27344V12.7274H9.09162V10.9092Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M12.7264 10.9092H10.9082V12.7274H12.7264V10.9092Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M16.3631 10.9092H14.5449V12.7274H16.3631V10.9092Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M5.4549 14.5459H3.63672V16.3641H5.4549V14.5459Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M9.09162 14.5459H7.27344V16.3641H9.09162V14.5459Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M12.7264 14.5459H10.9082V16.3641H12.7264V14.5459Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M16.3631 14.5459H14.5449V16.3641H16.3631V14.5459Z",
    fill: "white",
    fillOpacity: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.ac42dbb2dbff39472175887134c87312.svg";
export { ForwardRef as ReactComponent };